import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import {
  fetchUserDetail, createUser, updateUser, fetchRoles,
} from 'actions/Users'
import FormUserView from 'components/pages/users/Form'
import history from 'utils/history'
import Helper from 'utils/Helper'
import Browser from 'utils/Browser'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchUserDetail: bindActionCreators(fetchUserDetail, dispatch),
  createUser: bindActionCreators(createUser, dispatch),
  updateUser: bindActionCreators(updateUser, dispatch),
  fetchRoles: bindActionCreators(fetchRoles, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isSubmit', 'setIsSubmit', false),
  withState('isEdit', 'setIsEdit', false),
  withState('data', 'setData', {}),
  withState('roleList', 'setRoleList', {}),
  withHandlers({
    getDetail: props => async (id) => {
      const {
        setData, setImgFile, setCurrentImg,
      } = props

      try {
        const res = await props.fetchUserDetail(id)
        setData(res)
      } catch (err) {
        setData()
      }
    },
    getRoles: props => async (params) => {
      const { setRoleList } = props
      try {
        const res = await props.fetchRoles(params)
        setRoleList(res)
      } catch (err) {
        setRoleList()
      }
    },
    handleSubmit: props => (values) => {
      props.setIsSubmit(true)

      if (props.isEdit) {
        props.updateUser(props.match.params.id, values)
          .then(() => {
            message.success('Pengguna telah diperbarui')
            props.setIsSubmit(false)
            Browser.setWindowHref('/user/list')
          })
          .catch((error) => {
            props.setIsSubmit(false)
          })
      } else {
        props.createUser(values)
          .then(() => {
            message.success('Pengguna baru telah ditambahkan')
            props.setIsSubmit(false)
            Browser.setWindowHref('/user/list')
          })
          .catch((error) => {
            props.setIsSubmit(false)
          })
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        match, setIsEdit, getDetail, getRoles
      } = this.props
      this.props.updateSiteConfigs({
        titlePage: 'Form Pengguna',
        activePage: 'user/list',
        activeSubPage: 'user',
      })
      getRoles()
      if (match.params.id) {
        setIsEdit(true)
        getDetail(match.params.id)
      }
    },
  }),
)(FormUserView)
